import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  slides = [
    { image: './assets/carousel/1.jpg' },
    { image: './assets/carousel/3.jpg' },
    { image: './assets/carousel/2.jpg' },

  ];

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService) { }

  ngOnInit() {
  }

}
